export default "__VITE_ASSET__ClSsM35D__";